/**
 * @fileoverview GET handler for the "/:app_group_id/playwright/scan_a11y" endpoint
 * This is a "fake GET" that internally calls the POST endpoint to work with useDashboardApiQuery
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdPlaywrightScanA11y } from "./constants";
import type {
  GetAppGroupIdPlaywrightScanA11yProps,
  PlaywrightScanA11yResult,
  PostAppGroupIdPlaywrightScanA11yPayload,
} from "./types";
import { isPlaywrightScanA11yResult } from "./validators";

export const getAppGroupIdPlaywrightScanA11y = reactQueryFetcherAdapter(
  appGroupIdPlaywrightScanA11y,
  async (
    _signal,
    { appGroupId, html, isFullDocument, locale, pmAnalyticsLabel, logEvent }: GetAppGroupIdPlaywrightScanA11yProps
  ): Promise<PlaywrightScanA11yResult> => {
    const payload: PostAppGroupIdPlaywrightScanA11yPayload = {
      html,
      is_full_document: isFullDocument,
      locale,
    };

    try {
      const result = await fetch(
        `/${appGroupId}/playwright/scan_a11y`,
        "POST",
        payload,
        {},
        { propagateFetchRequestError: false }
      );

      if (logEvent && pmAnalyticsLabel) {
        logEvent(`pm.${pmAnalyticsLabel}.a11y-scanner.success`);
      }

      return result;
    } catch (error) {
      if (logEvent && pmAnalyticsLabel) {
        logEvent(`pm.${pmAnalyticsLabel}.a11y-scanner.error`);
      }
      throw error;
    }
  },
  isPlaywrightScanA11yResult
);
